<ng-container *ngIf="authStore.userHasAccessToInvitations() | async">
  <ng-container *ngIf="dataService.invitationsCount$ | async as count">
    <vi-icon-button
      *ngIf="!count"
      gtm="onGoToPage"
      gtmAction="Invitations"
      gtmCategory="header"
      routerLink="/invitations"
      data-at-button
    >
      <vi-icon name="envelope"></vi-icon>
    </vi-icon-button>
    <vi-icon-button
      *ngIf="count"
      gtm="onGoToPage"
      gtmAction="Invitations"
      gtmCategory="header"
      routerLink="/invitations"
      data-at-button
      [matBadge]="count"
    >
      <vi-icon name="envelope"></vi-icon>
    </vi-icon-button>
  </ng-container>
</ng-container>
